export const sortBy = (key, reverse, primer) => {
    const keyFunction = primer ? x => primer(x[key]) : x => x[key];

    return (a, b) => {
        const aKey = keyFunction(a);
        const bKey = keyFunction(b);

        if (aKey < bKey) return reverse ? 1 : -1;
        if (aKey > bKey) return reverse ? -1 : 1;
        return 0;
    };
};

export const sortProducts = (products, field, reverse, primer) => {
    return products.slice(0).sort(sortBy(field, reverse, primer));
};

export default sortProducts;